<template>
    <div class="fixed z-10000000 w-full">
        <div
            class="fixed right-7 top-[52px] z-10000000 z-501 ml-7 md:absolute md:right-20 md:top-14"
        >
            <transition
                enter-active-class="transition duration-200 ease-out"
                enter-from-class="translate-y-1 opacity-0"
                enter-to-class="translate-y-0 opacity-100"
                leave-active-class="transition duration-150 ease-in"
                leave-from-class="translate-y-0 opacity-100"
                leave-to-class="translate-y-1 opacity-0"
            >
                <Announcements
                    v-if="announcementsOpened"
                    v-click-away="closeAnnouncements"
                ></Announcements>
            </transition>
        </div>

        <div
            class="fixed z-10000000 z-500 flex h-14 w-full items-center justify-between bg-[#161E2E] md:relative md:h-16"
            @click.self="handleCloseSideBarMobile"
        >
            <div class="flex items-center">
                <inertia-link href="/" class="hidden md:block">
                    <div class="flex items-center justify-center">
                        <IconLogo height="26" class="" />
                    </div>
                </inertia-link>
                <TeamMenu
                    class="sm:hidden"
                    :sidebar="false"
                    @closeMenuMobile="handleCloseSideBarMobile"
                />
                <SideBarMobile
                    class="overflow-y-scroll"
                    :opened="sideBarMobileOpened"
                    @close="handleCloseSideBarMobile"
                />
            </div>

            <div class="z-10000000 mr-6 hidden items-center md:flex">
                <inertia-link
                    v-if="
                        globalProps.isSubscribed ||
                        globalProps.isTrialing ||
                        globalProps.hasGodMode
                    "
                    :href="route('settings.mcp-server.index')"
                    class="group mr-6 inline-flex items-center gap-2"
                >
                    <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.72767 3.71153L6.11108 3.06688C5.62483 2.87297 5.24456 2.48061 5.06596 1.98854L4.51875 0.480896C4.48598 0.39061 4.46796 0.293122 4.41694 0.211742C4.3326 0.0772051 4.17132 2.01427e-08 4.01004 2.03314e-08C3.8849 2.04778e-08 3.73633 0.0726224 3.65208 0.199737C3.59387 0.287551 3.5735 0.39477 3.53605 0.493244L2.95752 2.01474C2.77631 2.49132 2.40497 2.87101 1.93254 3.06276L0.489155 3.64862C0.386049 3.69047 0.272148 3.71355 0.183321 3.78057C0.0664921 3.86872 7.6341e-06 4.01736 7.63425e-06 4.1431C7.63444e-06 4.30566 0.0711269 4.46822 0.195507 4.55698C0.278135 4.61594 0.381746 4.63626 0.476397 4.67293L1.90556 5.22665C2.39396 5.41588 2.77822 5.80482 2.96151 6.29548L3.59233 7.9841C3.6341 8.15673 3.84295 8.2862 4.01004 8.2862C4.21889 8.2862 4.42775 8.15673 4.46952 7.9841L5.06237 6.32152C5.2428 5.81556 5.63587 5.41406 6.1379 5.22297L7.72767 4.61783C7.89475 4.57467 8.02007 4.35889 8.02007 4.1431C8.02007 3.97047 7.89475 3.75468 7.72767 3.71153ZM12.8238 3.19364L10.9283 7.48689C10.7499 7.89105 10.4316 8.21726 10.032 8.4056L5.88974 10.3577C5.63911 10.4872 5.47203 10.7462 5.47203 11.0051C5.47203 11.2641 5.63911 11.523 5.88974 11.6093L10.0411 13.6034C10.4351 13.7926 10.7487 14.1164 10.9252 14.5163L12.8238 18.8166C12.9491 19.0755 13.1997 19.2481 13.4503 19.2481C13.7009 19.2481 13.9516 19.0755 14.0351 18.8166L15.9709 14.5146C16.1504 14.1158 16.4664 13.7942 16.862 13.6078L21.0109 11.6525C21.2615 11.523 21.3868 11.2641 21.3868 11.0051C21.3868 10.7462 21.2615 10.4872 21.0109 10.3577L16.862 8.40245C16.4664 8.21602 16.1504 7.89442 15.9709 7.49561L14.0351 3.19364C13.9516 2.9347 13.7009 2.76207 13.4503 2.76207C13.1997 2.76207 12.9491 2.9347 12.8238 3.19364Z"
                            fill="url(#paint0_linear_6149_45380)"
                        />
                        <defs>
                            <linearGradient
                                id="paint0_linear_6149_45380"
                                x1="10.6934"
                                y1="2.77987"
                                x2="10.6934"
                                y2="19.2481"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FF421E" />
                                <stop offset="1" stop-color="#FFBE15" />
                            </linearGradient>
                        </defs>
                    </svg>
                    <span
                        class="font-['Inter'] text-[14px] font-medium leading-[18.765px] text-[#DEDEDE] transition-colors duration-200 group-hover:text-[#FFBE15]"
                    >
                        {{ t("vue.try_mcp_server_now") }}
                    </span>
                </inertia-link>

                <inertia-link
                    v-if="globalProps.isAdmin && isInKiosk"
                    :href="route('home')"
                >
                    <div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        Go Back to App
                    </div>
                </inertia-link>

                <inertia-link
                    v-if="globalProps.isAdmin && !isInKiosk"
                    :href="route('kiosk.teams.index')"
                >
                    <div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        Kiosk
                    </div>
                </inertia-link>

                <div
                    v-if="globalProps.isAdmin && !isInKiosk"
                    class="h-8 w-px bg-[#364152]"
                ></div>

                <OpenAnnouncementButton
                    :announcements-opened="announcementsOpened"
                    :has-unread-announcements="hasUnreadAnnouncements"
                    @toggle-announcements="toggleAnnouncements"
                ></OpenAnnouncementButton>

                <!--                <div class="mr-6 h-8 w-px bg-gray-500"></div>-->

                <ProfileMenu class="shrink-0" />
            </div>
            <div class="mr-3 flex items-center sm:mr-6 md:hidden">
                <OpenAnnouncementButton
                    :announcements-opened="announcementsOpened"
                    :has-unread-announcements="hasUnreadAnnouncements"
                    @toggle-announcements="toggleAnnouncements"
                ></OpenAnnouncementButton>
                <div
                    class="relative flex h-6 w-6 cursor-pointer items-center justify-center"
                    @click="handleSideBarMobile"
                >
                    <transition
                        enter-active-class="transition ease-in-out duration-800"
                        enter-from-class="transform opacity-0 scale-10"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-200 ease-in"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div v-if="!sideBarMobileOpened" class="absolute">
                            <svg
                                width="24"
                                height="16"
                                viewBox="0 0 24 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M0 0H24V2H0V0ZM0 7H24V9H0V7ZM16.32 14H0V16H16.32V14Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </transition>
                    <transition
                        enter-active-class="transition duration-1000 ease-in-out"
                        enter-from-class="transform rotate-180 opacity-0 scale-80"
                        enter-to-class="transform scale-100 rotate-0 opacity-100"
                        leave-active-class="transition duration-100 ease-in"
                        leave-from-class="transform opacity-100"
                        leave-to-class="transform opacity-0"
                    >
                        <div v-if="sideBarMobileOpened" class="absolute">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M10.7072 9.29299L1.41421 0L0 1.41421L9.29299 10.7072L4.60148e-05 20.0001L1.41426 21.4144L10.7072 12.1214L19.799 21.2132L21.2132 19.799L12.1214 10.7072L21.2132 1.61537L19.799 0.201156L10.7072 9.29299Z"
                                    fill="#FFC000"
                                />
                            </svg>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { usePage } from "@inertiajs/vue3";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { computed, ref } from "vue";
import route from "ziggy-js";
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

onMounted(() => {
    getHasUnreadAnnouncements();
});

const hasUnreadAnnouncements = ref(false);
const sideBarMobileOpened = ref(false);
const announcementsOpened = ref(false);

const globalProps = computed(() => usePage<IRhizomPageProps>().props);

const isAdmin = computed(() => {
    return globalProps.value.isAdmin;
});

const isInKiosk = computed(() => {
    return usePage<IRhizomPageProps>().url.startsWith("/kiosk");
});

const handleSideBarMobile = () => {
    sideBarMobileOpened.value = !sideBarMobileOpened.value;
};

const getHasUnreadAnnouncements = async () => {
    try {
        const response = await axios.get(
            route("user.has-unread-announcements.index"),
        );
        if (response.data.success) {
            hasUnreadAnnouncements.value = response.data.data;
        }
    } catch (error) {
        () => undefined;
    }
};

const toggleAnnouncements = () => {
    if (announcementsOpened.value) {
        announcementsOpened.value = false;
        getHasUnreadAnnouncements();
    } else {
        announcementsOpened.value = true;
    }
};

const closeAnnouncements = () => {
    announcementsOpened.value = false;
    getHasUnreadAnnouncements();
};

const handleCloseSideBarMobile = () => {
    sideBarMobileOpened.value = false;
};
</script>
